export default "/_next/static/images/site_astrobyte_logo.07b5c3a4-791148f321d5c98e625e8089bc53dfd9.png";